// ** MUI Imports
import Box, { BoxProps } from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useTheme } from '@mui/material/styles'
import {Backdrop} from "@mui/material";

const ItaptecSpinner = ({ sx }: { sx?: BoxProps['sx'] }) => {
  // ** Hook
  const theme = useTheme()

  return (
      <Backdrop open sx={{
          zIndex: '99999',
          backgroundColor: `${theme.palette.customColors.bodyBg}ed`,
          pointerEvents: 'all',
      }}>
            <Box
              sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                  
                ...sx
              }}
            >
              <img
                src={`/images/logo-puente.svg`}
                height={'35'}
                alt={`logo-img`}
              />
        
              <CircularProgress disableShrink sx={{ mt: 6 }} />
            </Box>
      </Backdrop>
  )
}

export default ItaptecSpinner
